if (!customElements.get("sticky-atc")) {
  customElements.define(
    "sticky-atc",
    class StickyAtc extends HTMLElement {
      constructor() {
        super();
        this.selectors = {
          prodTitle: ".m-sticky-addtocart--title",
          mainImage: ".m-sticky-addtocart--image",
          addToCart: ".m-add-to-cart",
          buyNowBtn: ".m-product-dynamic-checkout",
          variantIdSelect: '[name="id"]',
          foxkitBtn: ".foxkit-button",
        };
        this.hasCustomFields = !!document.querySelector(".m-main-product--info .m-product-custom-field");
      }

      connectedCallback() {
        this.container = this.closest(".m-sticky-addtocart");
        this.mainProductForm = document.querySelector(".m-product-form--main");
        this.mainProductInfo = document.querySelector(".m-main-product--info");
        this.mainAddToCart = this.mainProductForm.querySelector(".m-add-to-cart");
        this.mainDynamicCheckout = this.mainProductForm.querySelector(this.selectors.buyNowBtn);
        this.productId = this.dataset.productId;
        this.selectedVariantDefault = this.dataset.disableSelectedVariantDefault === "true";

        this.domNodes = queryDomNodes(this.selectors, this.container);

        this.variantData = this.getVariantData();

        const queryString = window.location.search;
        const hasQueryString = queryString.includes("?variant=");
        if (!hasQueryString && this.selectedVariantDefault && this.variantData && this.variantData.length > 1)
          this.disableSelectedVariantDefault();

        this.init();
        this.setStickyAddToCartHeight();

this.addEventListener("change", (e) => {
  const selectedVariantId = Number(
    this.querySelector(this.selectors.variantIdSelect)?.value
  );

  if (!selectedVariantId) return;

  let stickyVariant = this.variantData.find(
    (variant) => variant.id === selectedVariantId
  );

  if (!stickyVariant) {
    this.updateButton(true, "", true);
    return;
  }

  this.currentVariant = stickyVariant;
  this.updateButton(
    !stickyVariant.available,
    window.MinimogStrings.soldOut
  );

  // ignore sync if change came from main sync
  if (e.detail?.fromMainSync) return;

  const mainVariantPicker = document.querySelector("variant-picker");
  if (!mainVariantPicker?.productData?.variants) return;

  let targetVariant = stickyVariant;

  // UK: sticky EXC -> main INC equivalent
  if (
    mainVariantPicker.dataset.currentCountry === "GB" &&
    stickyVariant.options?.[0]?.toLowerCase().includes("exc")
  ) {
    const mappedVariant = mainVariantPicker.productData.variants.find(
      (variant) =>
        variant.options?.[0]?.toLowerCase().includes("inc") &&
        variant.options.slice(1).every(
          (opt, i) => opt === stickyVariant.options.slice(1)[i]
        )
    );

    if (mappedVariant) targetVariant = mappedVariant;
  }

  const mainSelects = mainVariantPicker.querySelectorAll(
    'select[name^="options"]'
  );

  targetVariant.options.forEach((optionValue, index) => {
    const select = mainSelects[index];
    if (!select || select.value === optionValue) return;

    select.value = optionValue;
    select.dispatchEvent(new Event("change", { bubbles: true }));
  });
});
        document.addEventListener("matchMobile", () => {
          this.setStickyAddToCartHeight();
        });
        document.addEventListener("unmatchMobile", () => {
          this.setStickyAddToCartHeight();
        });
      }

      getVariantData() {
        this.variantData =
          this.variantData || JSON.parse(this.container.querySelector('[type="application/json"]').textContent);
        return this.variantData;
      }

      init() {
      this.hideSelectfornooptions()
        if (!this.mainAddToCart) {
          this.container.style.setProperty("--m-translate-y", 0);
          return;
        }
        const { prodTitle, mainImage, addToCart, buyNowBtn, foxkitBtn } = this.domNodes;
        if (buyNowBtn) this.enable_dynamic_checkout = true;
        const headerHeight = MinimogSettings.headerHeight || 66;
        const rootMargin = `${headerHeight}px 0px 0px 0px`;

        if ("IntersectionObserver" in window) {
          this.observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.intersectionRatio !== 1) {
                  this.container.style.setProperty("--m-translate-y", 0);
                } else {
                  this.container.style.setProperty("--m-translate-y", "100%");
                }
                document.documentElement.classList[entry.intersectionRatio !== 1 ? "add" : "remove"]("stick-atc-show");
              });
            },
            { threshold: 1, rootMargin }
          );
        }

        prodTitle.addEventListener("click", () => __scrollToTop());
        mainImage.addEventListener("click", () => __scrollToTop());

        if (this.hasCustomFields) {
          let hasCustomFieldRequired = false;
          const customFields = document.querySelectorAll(".m-main-product--info .m-product-custom-field");
          customFields &&
            customFields.forEach((item) => {
              const field = item.querySelector(".form-field");
              if (field.value == "" && field.hasAttribute("required")) {
                hasCustomFieldRequired = true;
              }
            });
          hasCustomFieldRequired &&
            addToCart.addEventListener("click", (e) => {
              e.preventDefault();
              e.stopPropagation();
              __scrollToTop(this.mainProductForm, () => this.mainAddToCart.click());
            });
          if (buyNowBtn) {
            buyNowBtn.addEventListener(
              "click",
              (e) => {
                const missing = validateForm(this.mainProductInfo);
                if (missing.length > 0) {
                  e.preventDefault();
                  e.stopPropagation();
                  __scrollToTop(this.mainProductForm, () => this.mainDynamicCheckout.click());
                }
              },
              true
            );
          }
          if (foxkitBtn) {
            foxkitBtn.addEventListener("click", (e) => {
              e.preventDefault();
              __scrollToTop(this.mainProductForm, () => this.mainAddToCart.click());
            });
          }
        }

        this.setObserveTarget();
        this.syncWithMainProductForm();

        // SYNC STICKY ATC WITH MAIN VARIANT PICKER ON LOAD

      }
hideSelectfornooptions(){
  this.selectDropdown = this.querySelector(".m-product-option--dropdown-select");
  this.optionsSelect = Array.from(this.selectDropdown.children)
  if(this.optionsSelect.length<=2){
    this.selectDropdown.style.opacity ="0"
  }
}
      setObserveTarget() {
        if (this.observer) {
          this.observer.observe(this.mainProductForm);
          this.observeTarget = this.mainProductForm;
        }
      }

      checkDevice(e) {
        const sectionHeight = this.clientHeight + "px";
        document.documentElement.style.setProperty("--f-sticky-atc-bar-height", sectionHeight);
      }

      disableSelectedVariantDefault() {
        const pickerSelects = this.querySelector(".m-product-option--dropdown-select");
        if (!pickerSelects) return;
        pickerSelects.value = "";
      }

      updateButton(disable = true, text, modifyClass = true) {
        const productForm = this.querySelector(".sticky-atc-form");
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"] > .m-add-to-cart--text');

        if (!addButton) return;

        if (disable) {
          addButton.setAttribute("disabled", "disabled");
          if (text) addButtonText.textContent = text;
        } else {
          addButton.removeAttribute("disabled");
          addButton.classList.remove("disabled");
          addButtonText.textContent = window.MinimogStrings.addToCart;
        }
      }

  syncWithMainProductForm() {
  window.MinimogEvents.subscribe(
    `${this.productId}__VARIANT_CHANGE`,
    (variant) => {
      if (!variant) return;

      let stickyVariant = variant;

      // UK main INC -> sticky EXC equivalent
      if (variant.options?.[0]?.toLowerCase().includes("inc")) {
        const mappedVariant = this.variantData.find(
          (v) =>
            v.options?.[0]?.toLowerCase().includes("exc") &&
            v.options.slice(1).every(
              (opt, i) => opt === variant.options.slice(1)[i]
            )
        );

        if (mappedVariant) stickyVariant = mappedVariant;
      }

      const variantInput = this.querySelector('[name="id"]');
      if (variantInput) {
        variantInput.value = stickyVariant.id;
      }

      const stickySelects = this.querySelectorAll(
        'select[name^="options"]'
      );

      stickyVariant.options.forEach((optionValue, index) => {
        const select = stickySelects[index];
        if (!select) return;

        select.value = optionValue;
      });

      this.currentVariant = stickyVariant;

      this.updateButton(
        !stickyVariant.available,
        window.MinimogStrings.soldOut
      );
    }
  );
}

//        syncWithMainProductForm() {
//   const variantInput = this.querySelector('[name="id"]');

//   window.MinimogEvents.subscribe(
//     `${this.productId}__VARIANT_CHANGE`,
//     async (variant) => {
//       if (!variant) return;

//       // Update hidden input
//       variantInput.value = variant.id;

//       // Update dropdowns
//       const selects = this.querySelectorAll(
//         ".m-product-option--dropdown-select"
//       );

//       variant.options.forEach((optionValue, index) => {
//         if (selects[index]) {
//           selects[index].value = optionValue;
//           selects[index].dispatchEvent(
//             new Event("change", { bubbles: true })
//           );
//         }
//       });

//       // Update radio buttons
//       variant.options.forEach((optionValue) => {
//         const radio = this.querySelector(
//           `input[value="${optionValue}"]`
//         );

//         if (radio) {
//           radio.checked = true;
//         }
//       });

//       this.currentVariant = variant;

//       this.updateButton(
//         !variant.available,
//         window.MinimogStrings.soldOut
//       );
//     }
//   );
// }
      setStickyAddToCartHeight() {
        document.documentElement.style.setProperty("--f-sticky-atc-bar-height", this.offsetHeight + "px");
        window.MinimogSettings.stickyAddToCartHeight = this.offsetHeight;
      }
    }
  );
}
if (!customElements.get("sticky-atc")) {
  customElements.define(
    "sticky-atc",
    class StickyAtc extends HTMLElement {
      constructor() {
        super();
        this.selectors = {
          prodTitle: ".m-sticky-addtocart--title",
          mainImage: ".m-sticky-addtocart--image",
          addToCart: ".m-add-to-cart",
          buyNowBtn: ".m-product-dynamic-checkout",
          variantIdSelect: '[name="id"]',
          foxkitBtn: ".foxkit-button",
        };
        this.hasCustomFields = !!document.querySelector(".m-main-product--info .m-product-custom-field");
      }

      connectedCallback() {
        this.container = this.closest(".m-sticky-addtocart");
        this.mainProductForm = document.querySelector(".m-product-form--main");
        this.mainProductInfo = document.querySelector(".m-main-product--info");
        this.mainAddToCart = this.mainProductForm.querySelector(".m-add-to-cart");
        this.mainDynamicCheckout = this.mainProductForm.querySelector(this.selectors.buyNowBtn);
        this.productId = this.dataset.productId;
        this.selectedVariantDefault = this.dataset.disableSelectedVariantDefault === "true";

        this.domNodes = queryDomNodes(this.selectors, this.container);

        this.variantData = this.getVariantData();

        const queryString = window.location.search;
        const hasQueryString = queryString.includes("?variant=");
        if (!hasQueryString && this.selectedVariantDefault && this.variantData && this.variantData.length > 1)
          this.disableSelectedVariantDefault();

        this.init();
        this.setStickyAddToCartHeight();

this.addEventListener("change", (e) => {
  const selectedVariantId = Number(
    this.querySelector(this.selectors.variantIdSelect)?.value
  );

  if (!selectedVariantId) return;

  let stickyVariant = this.variantData.find(
    (variant) => variant.id === selectedVariantId
  );

  if (!stickyVariant) {
    this.updateButton(true, "", true);
    return;
  }

  this.currentVariant = stickyVariant;
  this.updateButton(
    !stickyVariant.available,
    window.MinimogStrings.soldOut
  );

  // ignore sync if change came from main sync
  if (e.detail?.fromMainSync) return;

  const mainVariantPicker = document.querySelector("variant-picker");
  if (!mainVariantPicker?.productData?.variants) return;

  let targetVariant = stickyVariant;

  // UK: sticky EXC -> main INC equivalent
  if (
    mainVariantPicker.dataset.currentCountry === "GB" &&
    stickyVariant.options?.[0]?.toLowerCase().includes("exc")
  ) {
    const mappedVariant = mainVariantPicker.productData.variants.find(
      (variant) =>
        variant.options?.[0]?.toLowerCase().includes("inc") &&
        variant.options.slice(1).every(
          (opt, i) => opt === stickyVariant.options.slice(1)[i]
        )
    );

    if (mappedVariant) targetVariant = mappedVariant;
  }

  const mainSelects = mainVariantPicker.querySelectorAll(
    'select[name^="options"]'
  );

  targetVariant.options.forEach((optionValue, index) => {
    const select = mainSelects[index];
    if (!select || select.value === optionValue) return;

    select.value = optionValue;
    select.dispatchEvent(new Event("change", { bubbles: true }));
  });
});
        document.addEventListener("matchMobile", () => {
          this.setStickyAddToCartHeight();
        });
        document.addEventListener("unmatchMobile", () => {
          this.setStickyAddToCartHeight();
        });
      }

      getVariantData() {
        this.variantData =
          this.variantData || JSON.parse(this.container.querySelector('[type="application/json"]').textContent);
        return this.variantData;
      }

      init() {
      this.hideSelectfornooptions()
        if (!this.mainAddToCart) {
          this.container.style.setProperty("--m-translate-y", 0);
          return;
        }
        const { prodTitle, mainImage, addToCart, buyNowBtn, foxkitBtn } = this.domNodes;
        if (buyNowBtn) this.enable_dynamic_checkout = true;
        const headerHeight = MinimogSettings.headerHeight || 66;
        const rootMargin = `${headerHeight}px 0px 0px 0px`;

        if ("IntersectionObserver" in window) {
          this.observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.intersectionRatio !== 1) {
                  this.container.style.setProperty("--m-translate-y", 0);
                } else {
                  this.container.style.setProperty("--m-translate-y", "100%");
                }
                document.documentElement.classList[entry.intersectionRatio !== 1 ? "add" : "remove"]("stick-atc-show");
              });
            },
            { threshold: 1, rootMargin }
          );
        }

        prodTitle.addEventListener("click", () => __scrollToTop());
        mainImage.addEventListener("click", () => __scrollToTop());

        if (this.hasCustomFields) {
          let hasCustomFieldRequired = false;
          const customFields = document.querySelectorAll(".m-main-product--info .m-product-custom-field");
          customFields &&
            customFields.forEach((item) => {
              const field = item.querySelector(".form-field");
              if (field.value == "" && field.hasAttribute("required")) {
                hasCustomFieldRequired = true;
              }
            });
          hasCustomFieldRequired &&
            addToCart.addEventListener("click", (e) => {
              e.preventDefault();
              e.stopPropagation();
              __scrollToTop(this.mainProductForm, () => this.mainAddToCart.click());
            });
          if (buyNowBtn) {
            buyNowBtn.addEventListener(
              "click",
              (e) => {
                const missing = validateForm(this.mainProductInfo);
                if (missing.length > 0) {
                  e.preventDefault();
                  e.stopPropagation();
                  __scrollToTop(this.mainProductForm, () => this.mainDynamicCheckout.click());
                }
              },
              true
            );
          }
          if (foxkitBtn) {
            foxkitBtn.addEventListener("click", (e) => {
              e.preventDefault();
              __scrollToTop(this.mainProductForm, () => this.mainAddToCart.click());
            });
          }
        }

        this.setObserveTarget();
        this.syncWithMainProductForm();

        // SYNC STICKY ATC WITH MAIN VARIANT PICKER ON LOAD

      }
hideSelectfornooptions(){
  this.selectDropdown = this.querySelector(".m-product-option--dropdown-select");
  this.optionsSelect = Array.from(this.selectDropdown.children)
  if(this.optionsSelect.length<=2){
    this.selectDropdown.style.opacity ="0"
  }
}
      setObserveTarget() {
        if (this.observer) {
          this.observer.observe(this.mainProductForm);
          this.observeTarget = this.mainProductForm;
        }
      }

      checkDevice(e) {
        const sectionHeight = this.clientHeight + "px";
        document.documentElement.style.setProperty("--f-sticky-atc-bar-height", sectionHeight);
      }

      disableSelectedVariantDefault() {
        const pickerSelects = this.querySelector(".m-product-option--dropdown-select");
        if (!pickerSelects) return;
        pickerSelects.value = "";
      }

      updateButton(disable = true, text, modifyClass = true) {
        const productForm = this.querySelector(".sticky-atc-form");
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"] > .m-add-to-cart--text');

        if (!addButton) return;

        if (disable) {
          addButton.setAttribute("disabled", "disabled");
          if (text) addButtonText.textContent = text;
        } else {
          addButton.removeAttribute("disabled");
          addButton.classList.remove("disabled");
          addButtonText.textContent = window.MinimogStrings.addToCart;
        }
      }

  syncWithMainProductForm() {
  window.MinimogEvents.subscribe(
    `${this.productId}__VARIANT_CHANGE`,
    (variant) => {
      if (!variant) return;

      let stickyVariant = variant;

      // UK main INC -> sticky EXC equivalent
      if (variant.options?.[0]?.toLowerCase().includes("inc")) {
        const mappedVariant = this.variantData.find(
          (v) =>
            v.options?.[0]?.toLowerCase().includes("exc") &&
            v.options.slice(1).every(
              (opt, i) => opt === variant.options.slice(1)[i]
            )
        );

        if (mappedVariant) stickyVariant = mappedVariant;
      }

      const variantInput = this.querySelector('[name="id"]');
      if (variantInput) {
        variantInput.value = stickyVariant.id;
      }

      const stickySelects = this.querySelectorAll(
        'select[name^="options"]'
      );

      stickyVariant.options.forEach((optionValue, index) => {
        const select = stickySelects[index];
        if (!select) return;

        select.value = optionValue;
      });

      this.currentVariant = stickyVariant;

      this.updateButton(
        !stickyVariant.available,
        window.MinimogStrings.soldOut
      );
    }
  );
}

//        syncWithMainProductForm() {
//   const variantInput = this.querySelector('[name="id"]');

//   window.MinimogEvents.subscribe(
//     `${this.productId}__VARIANT_CHANGE`,
//     async (variant) => {
//       if (!variant) return;

//       // Update hidden input
//       variantInput.value = variant.id;

//       // Update dropdowns
//       const selects = this.querySelectorAll(
//         ".m-product-option--dropdown-select"
//       );

//       variant.options.forEach((optionValue, index) => {
//         if (selects[index]) {
//           selects[index].value = optionValue;
//           selects[index].dispatchEvent(
//             new Event("change", { bubbles: true })
//           );
//         }
//       });

//       // Update radio buttons
//       variant.options.forEach((optionValue) => {
//         const radio = this.querySelector(
//           `input[value="${optionValue}"]`
//         );

//         if (radio) {
//           radio.checked = true;
//         }
//       });

//       this.currentVariant = variant;

//       this.updateButton(
//         !variant.available,
//         window.MinimogStrings.soldOut
//       );
//     }
//   );
// }
      setStickyAddToCartHeight() {
        document.documentElement.style.setProperty("--f-sticky-atc-bar-height", this.offsetHeight + "px");
        window.MinimogSettings.stickyAddToCartHeight = this.offsetHeight;
      }
    }
  );
}
